/* BCL design system: reveal-on-scroll for .bl-reveal elements. */
(function () {
  if (window.blDesignInit) return;
  window.blDesignInit = true;

  var showAll = function (root) {
    (root || document).querySelectorAll('.bl-reveal').forEach(function (el) { el.classList.add('is-in'); });
  };

  if (!('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) {
    showAll();
    document.addEventListener('shopify:section:load', function (e) { showAll(e.target); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

  var observe = function (root) {
    (root || document).querySelectorAll('.bl-reveal:not(.is-in)').forEach(function (el) { observer.observe(el); });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observe(); });
  } else {
    observe();
  }
})();

/* Japanese line breaks for browsers without `word-break: auto-phrase` (Safari, Firefox):
   BudouX inserts <wbr> between phrases and keeps words whole. */
(function () {
  if (!/^ja\b/.test(document.documentElement.lang)) return;
  if (window.CSS && CSS.supports('word-break', 'auto-phrase')) return;
  var selector = '.bl :is(.bl-h1, .bl-h2, .bl-h3, .bl-display, .bl-lead, .bl-body, .bl-card__title, .bl-card__sub, .bl-faq__q span, .bl-credits__note, .bl-form__legal, .bl-prose p, .bl-prose li)';
  var run = function (root) {
    import('https://cdn.jsdelivr.net/npm/budoux@0.6.2/+esm').then(function (budoux) {
      var parser = budoux.loadDefaultJapaneseParser();
      (root || document).querySelectorAll(selector).forEach(function (el) {
        if (el.dataset.blPhrases) return;
        el.dataset.blPhrases = '1';
        parser.applyToElement(el);
      });
    }).catch(function () {});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); });
  else run();
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
